<div class="statement-review-container">
  <!-- Header with Filters and Actions -->
  <div class="review-header">
    <div class="header-top">
      <div class="title-section">
        <h2 class="review-title">
          <mat-icon>fact_check</mat-icon>
          Generated Statements ({{ filteredStatements.length }})
        </h2>
        @if (selectedStatementIds.length > 0) {
          <span class="selection-badge">
            {{ selectedStatementIds.length }} selected
          </span>
        }
      </div>

      <div class="header-actions">
        <button mat-icon-button [matMenuTriggerFor]="viewMenu" class="view-toggle">
          <mat-icon>{{ viewMode === 'cards' ? 'view_list' : 'view_module' }}</mat-icon>
        </button>
        <mat-menu #viewMenu="matMenu">
          <button mat-menu-item (click)="viewMode = 'cards'">
            <mat-icon>view_module</mat-icon>
            Card View
          </button>
          <button mat-menu-item (click)="viewMode = 'table'">
            <mat-icon>view_list</mat-icon>
            Table View
          </button>
        </mat-menu>

        @if (selectedStatementIds.length > 0) {
          <button mat-raised-button color="primary" (click)="handleAddToSurvey()" class="add-survey-btn">
            <mat-icon>add_circle</mat-icon>
            Add {{ selectedStatementIds.length }} to Survey
          </button>
          <button mat-raised-button color="accent" [matMenuTriggerFor]="exportMenu" class="export-btn">
            <mat-icon>download</mat-icon>
            Export {{ selectedStatementIds.length }} Selected
          </button>
          <mat-menu #exportMenu="matMenu">
            <button mat-menu-item (click)="exportSelectedToExcel()">
              <mat-icon>table_chart</mat-icon>
              Export as Excel (.xlsx)
            </button>
            <button mat-menu-item (click)="exportSelectedToWord()">
              <mat-icon>description</mat-icon>
              Export as Word (.doc)
            </button>
          </mat-menu>
        }
      </div>
    </div>

    <!-- Filters -->
    <div class="filters-section">
      <mat-form-field appearance="outline" class="search-field">
        <mat-label>Search statements...</mat-label>
        <input matInput [(ngModel)]="searchText" placeholder="Search by text, rationale, etc.">
        <mat-icon matPrefix>search</mat-icon>
        @if (searchText) {
          <button matSuffix mat-icon-button (click)="searchText = ''">
            <mat-icon>clear</mat-icon>
          </button>
        }
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Section</mat-label>
        <mat-select [(value)]="selectedSection">
          <mat-option value="all">All Sections</mat-option>
          @for (section of uniqueSections; track section) {
            <mat-option [value]="section">{{ section }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Evidence Level</mat-label>
        <mat-select [(value)]="selectedEvidenceLevel">
          <mat-option value="all">All Levels</mat-option>
          @for (level of uniqueEvidenceLevels; track level) {
            <mat-option [value]="level">{{ level }}</mat-option>
          }
        </mat-select>
      </mat-form-field>

      <mat-form-field appearance="outline">
        <mat-label>Compliance Risk</mat-label>
        <mat-select [(value)]="selectedComplianceRisk">
          <mat-option value="all">All Risks</mat-option>
          <mat-option value="low">Low</mat-option>
          <mat-option value="medium">Medium</mat-option>
          <mat-option value="high">High</mat-option>
        </mat-select>
      </mat-form-field>

      <mat-checkbox [(ngModel)]="showOnlySelected" class="show-selected-checkbox">
        Show only selected
      </mat-checkbox>

      <button mat-button (click)="clearFilters()" class="clear-filters-btn">
        <mat-icon>clear_all</mat-icon>
        Clear Filters
      </button>
    </div>

    <!-- Bulk Actions -->
    <div class="bulk-actions">
      <button mat-stroked-button (click)="selectAll()">
        <mat-icon>select_all</mat-icon>
        Select All ({{ filteredStatements.length }})
      </button>
      <button mat-stroked-button (click)="deselectAll()" [disabled]="selectedStatementIds.length === 0">
        <mat-icon>deselect</mat-icon>
        Deselect All
      </button>
    </div>
  </div>

  <!-- Cards View -->
  @if (viewMode === 'cards') {
    <div class="statements-grid">
      @for (statement of filteredStatements; track statement.id) {
        <mat-card class="statement-card" [class.selected]="isSelected(statement.id)" [class.expanded]="isExpanded(statement.id)">
          <!-- Card Header -->
          <mat-card-header>
            <mat-checkbox
              [checked]="isSelected(statement.id)"
              [disabled]="statement.is_in_draft_survey"
              (change)="toggleSelection(statement.id)"
              class="select-checkbox"
              (click)="$event.stopPropagation()">
            </mat-checkbox>

            <div class="card-header-content">
              <mat-card-title>{{ statement.statement_text }}</mat-card-title>
              <div class="badges-row">
                <span class="section-badge">{{ statement.section }}</span>
                <span class="evidence-badge" [ngClass]="getEvidenceBadgeClass(statement.level_of_evidence)">
                  LoE: {{ statement.level_of_evidence }}
                </span>
                <span class="grade-badge" [ngClass]="getGradeBadgeClass(statement.grade_of_recommendation)">
                  GoR: {{ statement.grade_of_recommendation }}
                </span>
                @if (statement.compliance) {
                  <span class="compliance-badge" [ngClass]="getComplianceRiskClass(statement.compliance.off_label_risk || statement.compliance['off_label_tone_risk_flag'])">
                    {{ statement.compliance.off_label_risk || statement.compliance['off_label_tone_risk_flag'] }} risk
                  </span>
                }
                @if (statement.is_in_draft_survey) {
                  <a [href]="'/#/surveys/' + statement.survey_id" target="_blank" class="in-survey-badge">
                    <mat-icon style="font-size:14px;height:14px;width:14px;vertical-align:middle;">check_circle</mat-icon>
                    In Survey
                    <mat-icon style="font-size:12px;height:12px;width:12px;vertical-align:middle;">open_in_new</mat-icon>
                  </a>
                }
              </div>
            </div>

            <button mat-icon-button (click)="toggleExpanded(statement.id)" class="expand-button">
              <mat-icon>{{ isExpanded(statement.id) ? 'expand_less' : 'expand_more' }}</mat-icon>
            </button>
          </mat-card-header>

          <!-- Card Content -->
          <mat-card-content>
            <!-- Collapsed View -->
            @if (!isExpanded(statement.id)) {
              <div class="compact-view">
                @if (statement.rationale) {
                  <p class="rationale-preview">{{ statement.rationale | slice:0:150 }}...</p>
                }
                @if (statement.confidence_score) {
                  <div class="confidence-bar">
                    <span class="confidence-label">Confidence:</span>
                    <div class="confidence-meter">
                      <div class="confidence-fill" [style.width.%]="statement.confidence_score * 100" [ngClass]="getConfidenceColor(statement.confidence_score)"></div>
                    </div>
                    <span class="confidence-value">{{ (statement.confidence_score * 100).toFixed(0) }}%</span>
                  </div>
                }
              </div>
            }

            <!-- Expanded View -->
            @if (isExpanded(statement.id)) {
              <div class="expanded-view">
                <!-- Rationale -->
                <div class="detail-section">
                  <h4 class="detail-title">
                    <mat-icon>description</mat-icon>
                    Rationale
                  </h4>
                  <p class="detail-content">{{ statement.rationale }}</p>
                </div>

                <!-- Why It Matters -->
                <div class="detail-section">
                  <h4 class="detail-title">
                    <mat-icon>star</mat-icon>
                    Why It Matters
                  </h4>
                  <p class="detail-content">{{ statement.why_it_matters }}</p>
                </div>

                <!-- What We Want to Elicit -->
                <div class="detail-section">
                  <h4 class="detail-title">
                    <mat-icon>help_outline</mat-icon>
                    What We Want to Elicit
                  </h4>
                  <p class="detail-content">{{ statement.what_we_want_to_elicit }}</p>
                </div>

                <!-- Evidence -->
                <div class="detail-section">
                  <h4 class="detail-title">
                    <mat-icon>science</mat-icon>
                    Evidence Summary
                  </h4>
                  <p class="detail-content">{{ statement.epistemic_summary }}</p>
                  @if (statement.comment) {
                    <p class="comment-text"><strong>Comment:</strong> {{ statement.comment }}</p>
                  }
                </div>

                <!-- References -->
                @if (statement.reference_links && statement.reference_links.length > 0) {
                  <div class="detail-section">
                    <h4 class="detail-title">
                      <mat-icon>link</mat-icon>
                      References ({{ statement.reference_links.length }})
                    </h4>
                    <div class="references-list">
                      @for (ref of statement.reference_links; track ref) {
                        @if (isReferenceLink(ref)) {
                          <a [href]="getReferenceUrl(ref)" target="_blank" class="reference-link">
                            <mat-icon>open_in_new</mat-icon>
                            {{ getReferenceLabel(ref) }}
                          </a>
                        } @else {
                          <div class="reference-detail">
                            <mat-icon>article</mat-icon>
                            <span>{{ getReferenceDetail(ref) }}</span>
                          </div>
                        }
                      }
                    </div>
                  </div>
                }

                <!-- Compliance -->
                @if (statement.compliance) {
                  <div class="detail-section">
                    <h4 class="detail-title">
                      <mat-icon>policy</mat-icon>
                      Compliance
                    </h4>
                    <div class="compliance-details">
                      <div class="compliance-item">
                        <span class="compliance-label">Off-Label Risk:</span>
                        <span class="compliance-value" [ngClass]="getComplianceRiskClass(statement.compliance.off_label_risk || statement.compliance['off_label_tone_risk_flag'])">
                          {{ statement.compliance.off_label_risk || statement.compliance['off_label_tone_risk_flag'] }}
                        </span>
                      </div>
                      @if (statement.compliance['off_label_rationale']) {
                        <p class="compliance-notes">{{ statement.compliance['off_label_rationale'] }}</p>
                      }
                      @if (statement.compliance.notes) {
                        <p class="compliance-notes">{{ statement.compliance.notes }}</p>
                      }
                      @if (statement.compliance.flags && statement.compliance.flags.length > 0) {
                        <div class="compliance-flags">
                          @for (flag of statement.compliance.flags; track flag) {
                            <span class="flag-chip">{{ flag }}</span>
                          }
                        </div>
                      }
                    </div>
                  </div>
                }

                <!-- Confidence -->
                @if (statement.confidence_score) {
                  <div class="detail-section">
                    <h4 class="detail-title">
                      <mat-icon>bar_chart</mat-icon>
                      Confidence Score
                    </h4>
                    <div class="confidence-display">
                      <div class="confidence-meter-large">
                        <div class="confidence-fill" [style.width.%]="statement.confidence_score * 100" [ngClass]="getConfidenceColor(statement.confidence_score)"></div>
                      </div>
                      <span class="confidence-percentage">{{ (statement.confidence_score * 100).toFixed(1) }}%</span>
                    </div>
                  </div>
                }
              </div>
            }
          </mat-card-content>
        </mat-card>
      }
    </div>
  }

  <!-- Table View -->
  @if (viewMode === 'table') {
    <div class="table-view">
      <table class="statements-table">
        <thead>
          <tr>
            <th class="checkbox-col">
              <mat-checkbox
                [checked]="selectedStatementIds.length === filteredStatements.length && filteredStatements.length > 0"
                [indeterminate]="selectedStatementIds.length > 0 && selectedStatementIds.length < filteredStatements.length"
                (change)="$event.checked ? selectAll() : deselectAll()">
              </mat-checkbox>
            </th>
            <th>Statement</th>
            <th>Section</th>
            <th>Evidence</th>
            <th>Grade</th>
            <th>Risk</th>
            <th>Confidence</th>
            <th>Actions</th>
          </tr>
        </thead>
        <tbody>
          @for (statement of filteredStatements; track statement.id) {
            <tr [class.selected]="isSelected(statement.id)">
              <td class="checkbox-col">
                <mat-checkbox
                  [checked]="isSelected(statement.id)"
                  (change)="toggleSelection(statement.id)">
                </mat-checkbox>
              </td>
              <td class="statement-col">
                <div class="statement-text-cell">{{ statement.statement_text }}</div>
              </td>
              <td>
                <span class="section-badge">{{ statement.section }}</span>
              </td>
              <td>
                <span class="evidence-badge" [ngClass]="getEvidenceBadgeClass(statement.level_of_evidence)">
                  {{ statement.level_of_evidence }}
                </span>
              </td>
              <td>
                <span class="grade-badge" [ngClass]="getGradeBadgeClass(statement.grade_of_recommendation)">
                  {{ statement.grade_of_recommendation }}
                </span>
              </td>
              <td>
                @if (statement.compliance) {
                  <span class="compliance-badge" [ngClass]="getComplianceRiskClass(statement.compliance.off_label_risk || statement.compliance['off_label_tone_risk_flag'])">
                    {{ statement.compliance.off_label_risk || statement.compliance['off_label_tone_risk_flag'] }}
                  </span>
                }
              </td>
              <td>
                <div class="confidence-mini">
                  {{ statement.confidence_score ? (statement.confidence_score * 100).toFixed(0) + '%' : '-' }}
                </div>
              </td>
              <td class="actions-col">
                <button mat-icon-button (click)="toggleExpanded(statement.id)"
                  [matTooltip]="isExpanded(statement.id) ? 'Chiudi dettaglio' : 'Visualizza dettaglio'">
                  <mat-icon>{{ isExpanded(statement.id) ? 'visibility_off' : 'visibility' }}</mat-icon>
                </button>
              </td>
            </tr>
            @if (isExpanded(statement.id)) {
              <tr class="detail-row">
                <td colspan="8" class="detail-cell">
                  <div class="table-detail-panel">
                    @if (statement.rationale) {
                      <div class="detail-section">
                        <h4 class="detail-title">Rationale</h4>
                        <p class="detail-content">{{ statement.rationale }}</p>
                      </div>
                    }
                    @if (statement.why_it_matters) {
                      <div class="detail-section">
                        <h4 class="detail-title">Why It Matters</h4>
                        <p class="detail-content">{{ statement.why_it_matters }}</p>
                      </div>
                    }
                    @if (statement.what_we_want_to_elicit) {
                      <div class="detail-section">
                        <h4 class="detail-title">What We Want to Elicit</h4>
                        <p class="detail-content">{{ statement.what_we_want_to_elicit }}</p>
                      </div>
                    }
                    @if (statement.epistemic_summary) {
                      <div class="detail-section">
                        <h4 class="detail-title">Evidence Summary</h4>
                        <p class="detail-content">{{ statement.epistemic_summary }}</p>
                      </div>
                    }
                    @if (statement.reference_links?.length) {
                      <div class="detail-section">
                        <h4 class="detail-title">References ({{ statement.reference_links.length }})</h4>
                        <div class="references-list">
                          @for (ref of statement.reference_links; track ref) {
                            @if (isReferenceLink(ref)) {
                              <a [href]="getReferenceUrl(ref)" target="_blank" class="reference-link">
                                <mat-icon>open_in_new</mat-icon>
                                {{ getReferenceLabel(ref) }}
                              </a>
                            } @else {
                              <div class="reference-detail">
                                <mat-icon>article</mat-icon>
                                <span>{{ getReferenceDetail(ref) }}</span>
                              </div>
                            }
                          }
                        </div>
                      </div>
                    }
                    @if (statement.compliance) {
                      <div class="detail-section">
                        <h4 class="detail-title">Compliance</h4>
                        <p class="detail-content">
                          Off-Label Risk: <strong>{{ statement.compliance.off_label_risk || statement.compliance['off_label_tone_risk_flag'] }}</strong>
                        </p>
                      </div>
                    }
                  </div>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  }

  <!-- Empty State -->
  @if (filteredStatements.length === 0) {
    <div class="empty-state">
      <mat-icon class="empty-icon">search_off</mat-icon>
      <h3>No statements found</h3>
      <p>Try adjusting your filters or search criteria</p>
      <button mat-raised-button color="primary" (click)="clearFilters()">
        Clear All Filters
      </button>
    </div>
  }
</div>
